import React, { useRef, useState } from "react";
import { Box, TextField, Typography, Stack } from "@mui/material";

const OtpInput = ({ otp, setOtp }) => {
  const inputRefs = useRef([]);

  // Handle input change for each OTP box
  const handleChange = (e, index) => {
    const { value } = e.target;

    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input box if not at the last one
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  // Handle keypress for backspace to move focus backward
  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      inputRefs.current[index - 1].focus();
    }
  };

  // Add paste handler
  const handlePaste = (e, index) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').trim();
    
    // Only process if we have data and it's not longer than our OTP length
    if (pastedData && pastedData.length <= otp.length) {
      const newOtp = [...otp];
      
      // Fill in the OTP array with pasted characters
      for (let i = 0; i < pastedData.length; i++) {
        if (index + i < otp.length) {
          newOtp[index + i] = pastedData[i];
        }
      }
      
      setOtp(newOtp);
      
      // Focus on the next empty input or the last input
      const nextIndex = Math.min(index + pastedData.length, otp.length - 1);
      inputRefs.current[nextIndex].focus();
    }
  };

  return (
    <Box>
      <Stack direction="row" gap={2} alignItems="center">
        <Typography>Enter the code:</Typography>
      </Stack>
      <Stack direction="row" gap={2}>
        {otp.map((data, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputRefs.current[index] = el)}
            value={otp[index]}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyPress(e, index)}
            onPaste={(e) => handlePaste(e, index)}
            sx={{
              borderRadius: "0px !important",
            }}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
              },
            }}
            variant="outlined"
          />
        ))}
      </Stack>
    </Box>
  );
};

export default OtpInput;
